/**
 * RowSlideIn — animation wrapper for list items.
 *
 * Relocated from legacy.tsx by T312 (FR-015).
 * Currently a pass-through wrapper; animation behavior
 * can be layered in via CSS or framer-motion in a future phase.
 */
import React from "react";
import type { ReactNode } from "react";

export interface RowSlideInProps {
  children: ReactNode;
}

export function RowSlideIn({ children }: RowSlideInProps) {
  return <div>{children}</div>;
}
